import styled from 'foundations-theming-specialty/utils';
import { SEARCH_IFRAME_OFFSET_BOTTOM, SEARCH_IFRAME_OFFSET_TOP } from '../../constants';
const IS_OPEN_TRELLIS_TEXT_COLOR = 'text-core-default';
const IS_CLOSED_TRELLIS_TEXT_COLOR = 'global-shell-text-nav-item-default';
const IS_OPEN_CANVAS_TEXT_COLOR = 'text-core-default';
const IS_CLOSED_CANVAS_TEXT_COLOR = 'text-inverse-default';
const getInputColor = (theme, isOpen, isTrellis) => {
  if (isOpen) {
    return theme.color[isTrellis ? IS_OPEN_TRELLIS_TEXT_COLOR : IS_OPEN_CANVAS_TEXT_COLOR];
  }
  return theme.color[isTrellis ? IS_CLOSED_TRELLIS_TEXT_COLOR : IS_CLOSED_CANVAS_TEXT_COLOR];
};
export const StyledSearchScrollableWrapper = styled.div.withConfig({
  displayName: "StyledSearchScrollableWrapper",
  componentId: "sc-15bxh4f-0"
})(["--search-input-color:", ";display:block !important;", ""], ({
  isOpen,
  theme,
  isTrellis
}) => getInputColor(theme, isOpen, isTrellis), ({
  isOpen,
  disableScroll,
  theme
}) => isOpen && `
        height: min-content !important;
        min-width: min(calc(var(--search-layout-width, 500px) + ${theme.space['600']} + ${theme.space['600']}), calc(100vw - var(--global-nav-vertical-nav-width) - 10px));
        overflow: ${disableScroll ? 'hidden' : 'auto'};
        position: relative;
        max-width: calc(100vw - var(--global-nav-vertical-nav-width) - 10px);
        max-height: calc(100vh - ${SEARCH_IFRAME_OFFSET_TOP}px - ${SEARCH_IFRAME_OFFSET_BOTTOM}px);
      `);